/**
 * app-bar-context.js
 */

import React, { createContext } from 'react';


const initialState =  {
  appBarTitle: '',
  appBarActions: [],
  setAppBar: (title, actions) => {},
};


export const AppBarContext = createContext(initialState);


export const AppBarProvider = ({ children }) => {

  const setAppBar = (appBarTitle, appBarActions) => {
    setAppBarState(p => ({
      ...p,
      appBarTitle,
      appBarActions
    }));
  }


  const [appBarState, setAppBarState] = React.useState({
    appBarTitle: '',
    appBarActions: [],
    setAppBar,
  });

  
  return (
    <AppBarContext.Provider value={appBarState}>
      {children}
    </AppBarContext.Provider>
  );
}